import React from 'react';
import { Grid, Typography, Divider, Box } from '@mui/material';
import { Room } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import GoogleMaps from 'js/components/StorePlaces/GoogleMaps';
import { trackEventMatomoElementId } from 'js/library/utils/helpers';

export const EstablishmentInfo = (props) => {
  const { t } = useTranslation();

  props = props.props;
  const [openEstablishmentDetails, setOpenEstablishmentDetails] = React.useState(false);

  const days = t('days').split('_');

  return (
    <div style={{ textAlign: '-webkit-center' }}>
      <Box sx={{ display: { lg: 'block', md: 'block', sm: 'none', xs: 'none' } }}>
        <img
          src={props.thumbnail}
          width="100%"
          alt="imagem da promoção"
          onClick={() =>
            trackEventMatomoElementId('Resgate por link externo', 'tocar', 'img-thumb', '')
          }
        />
        <div className="form-promotion">
          <div
            style={{
              margin: '10px 0',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <div style={{ width: '80%', float: 'left' }}>
              <Typography
                variant="h6"
                color="secondary"
                style={{ fontWeight: 'bolder', paddingBottom: '10px', textAlign: 'left' }}
                onClick={() =>
                  trackEventMatomoElementId('Resgate por link externo', 'tocar', 'title', '')
                }
              >
                {props.storeInfo.establishmentName}
              </Typography>
            </div>

            <div
              style={{ width: '20%', float: 'right', cursor: 'pointer' }}
              onClick={() =>
                trackEventMatomoElementId('Resgate por link externo', 'tocar', 'botão', 'ver mais')
              }
            >
              <span
                onClick={() => setOpenEstablishmentDetails(!openEstablishmentDetails)}
                style={{ textDecoration: 'underline', fontWeight: '500' }}
              >
                {t('general.show_more')}
              </span>
            </div>
          </div>

          <div
            style={{
              margin: '10px 0',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <div style={{ width: '10%', paddingRight: 10, float: 'left' }}>
              <Room
                style={{ fontSize: '2.5rem', maxWidth: '100%', display: 'block', color: '#235AA0' }}
              />
            </div>
            <div style={{ width: '90%', float: 'left' }}>{props.establishmentInfo.endereco}</div>
          </div>

          <Divider style={{ backgroundColor: '#3C3C3C', margin: '20px 0px' }} />

          {openEstablishmentDetails && (
            <>
              <div className="contentMaps">
                <GoogleMaps
                  onClick={() =>
                    trackEventMatomoElementId('Resgate por link externo', 'tocar', 'mapa', '')
                  }
                  establishmentInfo={props.establishmentInfo}
                />
              </div>

              <Typography
                variant="h6"
                color="secondary"
                style={{ fontWeight: 'bolder', paddingBottom: '10px' }}
              >
                {t('general.opening_hours')}
              </Typography>

              {Array.isArray(props.establishmentInfo.funcionamento) &&
                props.establishmentInfo.funcionamento.map(function (array, i) {
                  return (
                    <ul
                      key={i}
                      style={{ width: '80%', padding: 0, margin: '0 auto', listStyle: 'none' }}
                    >
                      <li key={i}>
                        <span style={{ float: 'left', width: '50%' }}>{days[i]}</span>
                        <span style={{ float: 'right', width: '50%', textAlign: 'right' }}>
                          {array.ativo
                            ? array.horarioInicio + '-' + array.horarioFim
                            : t('general.closed')}
                        </span>
                      </li>
                      <Divider style={{ margin: '10px 0px', float: 'right' }} width="100%" />
                    </ul>
                  );
                })}
            </>
          )}

          <Grid container>
            <Grid size={{ xs: 12, sm: 12 }}>
              <Typography
                variant="h6"
                color="secondary"
                style={{ fontWeight: 'bolder', paddingBottom: '10px' }}
                onClick={() =>
                  trackEventMatomoElementId('Resgate por link externo', 'tocar', 'title', '')
                }
              >
                {props.storeInfo.title}
              </Typography>

              <Typography
                onClick={() =>
                  trackEventMatomoElementId('Resgate por link externo', 'tocar', 'description', '')
                }
                variant="body1"
                style={{ whiteSpace: 'pre-line', width: '90%', paddingBottom: '10px' }}
              >
                {props.storeInfo.description}
              </Typography>
            </Grid>
          </Grid>
        </div>
      </Box>

      <Box sx={{ display: { lg: 'none', md: 'none', sm: 'block', xs: 'block' } }}>
        <div className="form-promotion">
          <Grid container spacing={0} alignItems="center" style={{ padding: '50px 0px' }}>
            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }} style={{ padding: '0px 5px' }}>
              <div className="contentMaps">
                <GoogleMaps
                  onClick={() =>
                    trackEventMatomoElementId('Resgate por link externo', 'tocar', 'mapa', '')
                  }
                  establishmentInfo={props.establishmentInfo}
                />
              </div>
              <div
                style={{
                  margin: '10px 0',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <div style={{ width: '15%', paddingRight: 10, float: 'left' }}>
                  <Room
                    style={{
                      fontSize: '2.5rem',
                      maxWidth: '100%',
                      display: 'block',
                      color: '#235AA0',
                    }}
                  />
                </div>
                <div style={{ width: '65%', float: 'left' }}>
                  {props.establishmentInfo.endereco}
                </div>
              </div>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }} style={{ padding: '0px 5px' }}>
              <Typography
                variant="subtitle1"
                color="secondary"
                style={{ fontWeight: 'bolder', paddingBottom: '10px' }}
              >
                {t('general.opening_hours')}
              </Typography>

              {Array.isArray(props.establishmentInfo.funcionamento)
                ? props.establishmentInfo.funcionamento.map(function (array, i) {
                    return (
                      <ul
                        key={i}
                        style={{ width: '80%', padding: 0, margin: '0 auto', listStyle: 'none' }}
                      >
                        <li key={i}>
                          <span style={{ float: 'left', width: '50%' }}>{days[i]}</span>
                          <span style={{ float: 'right', width: '50%', textAlign: 'right' }}>
                            {array.ativo
                              ? array.horarioInicio + '-' + array.horarioFim
                              : t('general.closed')}
                          </span>
                        </li>
                        <Divider style={{ margin: '10px 0px', float: 'right' }} width="100%" />
                      </ul>
                    );
                  })
                : null}
            </Grid>
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default EstablishmentInfo;
